export const initialValuesLogin = {
  Email: '',
  Password: '',
};
